export default "__VITE_ASSET__B2p1aGTp__";